export default {
    UNKNOWN: 'unknown',
    POOR: 'poor',
    FAIR: 'fair',
    GOOD: 'good',
    EXCELLENT: 'excellent',
    PREQUALIFIED: 'prequalified',
};
